import { Capacitor } from '@capacitor/core';

export function isStandaloneWebApp(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(display-mode: standalone)').matches;
}

export function isAndroidUserAgent(ua = typeof navigator !== 'undefined' ? navigator.userAgent : ''): boolean {
  return /Android/i.test(ua);
}

export function isIOSUserAgent(ua = typeof navigator !== 'undefined' ? navigator.userAgent : ''): boolean {
  return /iPad|iPhone|iPod/.test(ua) && !(window as Window & { MSStream?: unknown }).MSStream;
}

/** 手機瀏覽器官網（非 Capacitor、非已安裝 PWA） */
export function isMobileWebBrowser(): boolean {
  if (Capacitor.isNativePlatform()) return false;
  if (isStandaloneWebApp()) return false;
  return true;
}
